import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApisService } from 'app/services/apis.service';
import { LoadingService } from 'app/services/loading.service';

@Component({
  selector: 'app-payment-info',
  templateUrl: './payment-info.component.html',
  styleUrls: ['./payment-info.component.scss']
})
export class PaymentInfoComponent implements OnInit {
   public payment : any
   public id : any
  constructor(
    private activatedRoute : ActivatedRoute,
    private apiService: ApisService , 
    private loading : LoadingService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
       this.id = params['id'];
      this.paymentInfo(this.id)
      })
    }

  

  
  /*----------  Getting User Payment Info  ----------*/
  paymentInfo(id: any) {
    this.loading.show()
    this.apiService.paymentDetails(id).subscribe({
      next: (res: any) => {
        this.payment = res.data
        this.loading.hide()
      },
      error(err) {
        console.log("Fetching Error", err)
        this.loading.hide()
      },
    })
  }
  

}
